import React from "react"
import { connect } from "react-redux"
import QueryString from "query-string"
import _ from "lodash"
// import { Row } from "antd";
import UserList from "../../components/UserList/userList"
import AddUserForm from "./addUserForm"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import { getRolesListByFilters } from "appRedux/slices/rolesList"
import { getPermissions } from "appRedux/slices/permissions"
import {
  getUserListByFilters,
  upsertAppUser,
  getEmailsOfUsers,
  addUser,
  //   getAppUserDetails,
  resetState,
} from "appRedux/slices/usersList"
// import { getLocationData } from "appRedux/slices/location"
import Auxiliary from "../../util/Auxiliary"
import Chips from "components/CommonFilter/chips"
import { userFilters } from "../../constants/uiConstants"
import { Col, Button, Row, Container } from "reactstrap"
import { Modal } from "react-bootstrap"
import toastr from "toastr"
import { NO_PERMISSION_MESSAGE } from "../../constants/uiConstants"
import "./styles.css"

class BrowseUser extends ErrorBoundComponent {
  state = {
    selectedUser: {},
    userData: {},
    stateLocationList: [],
    cityLocationList: [],
    appCode: this.props?.appCode || "CREATOR_NETWORK",
    filters: {
      appCode: this.props?.appCode || "CREATOR_NETWORK",
      pageSize:
        this.props.queryParams && this.props.queryParams["pageSize"]
          ? this.props.queryParams["pageSize"]
          : 10,
      currentPage:
        this.props.queryParams && this.props.queryParams["currentPage"]
          ? this.props.queryParams["currentPage"]
          : 1,
      searchAfter:
        this.props.queryParams && this.props.queryParams["searchAfter"]
          ? this.props.queryParams["searchAfter"]
          : null,
      searchText:
        this.props.queryParams && this.props.queryParams["searchText"]
          ? this.props.queryParams["searchText"]
          : "",
      searchType:
        this.props.queryParams && this.props.queryParams["searchType"]
          ? this.props.queryParams["searchType"]
          : "user_uuid",
      creatorType:
        this.props.queryParams && this.props.queryParams["creatorType"]
          ? this.props.queryParams["creatorType"]
          : "",
      contentCreateLangs:
        this.props.queryParams && this.props.queryParams["contentCreateLangs"]
          ? this.props.queryParams["contentCreateLangs"]
          : "",
      userLangPrimary:
        this.props.queryParams && this.props.queryParams["userLangPrimary"]
          ? this.props.queryParams["userLangPrimary"]
          : "",
      rangeSearchType:
        this.props.queryParams && this.props.queryParams["rangeSearchType"]
          ? this.props.queryParams["rangeSearchType"]
          : null,
      opSearchType:
        this.props.queryParams && this.props.queryParams["opSearchType"]
          ? this.props.queryParams["opSearchType"]
          : null,
      rangeSearchText:
        this.props.queryParams && this.props.queryParams["rangeSearchText"]
          ? this.props.queryParams["rangeSearchText"]
          : null,
      rangeSearchFrom:
        this.props.queryParams && this.props.queryParams["rangeSearchFrom"]
          ? this.props.queryParams["rangeSearchFrom"]
          : null,
      rangeSearchTo:
        this.props.queryParams && this.props.queryParams["rangeSearchTo"]
          ? this.props.queryParams["rangeSearchTo"]
          : null,
      createdDateFrom:
        this.props.queryParams && this.props.queryParams["createdDateFrom"]
          ? this.props.queryParams["createdDateFrom"]
          : null,
      createdDateTo:
        this.props.queryParams && this.props.queryParams["createdDateTo"]
          ? this.props.queryParams["createdDateTo"]
          : null,
      orderByField:
        this.props.queryParams && this.props.queryParams["created_date"]
          ? this.props.queryParams["created_date"]
          : "created_date",
      order:
        this.props.queryParams && this.props.queryParams["order"]
          ? this.props.queryParams["order"]
          : "desc",
      fetchAllUsers: this.props.fetchAllUsers || false,
      fetchActiveRoles: true,
    },
    previewUser: false,
  }

  componentDidMount() {
    if (!this.props.common.error) {
      let filters = _.deepClean(this.state.filters)
      if (this.props.currentUser && this.props.currentUser.jotUserType === 6) {
        filters.brandUsers = "Y"
      } else if (
        this.props.currentUser &&
        this.props.currentUser.jotUserType === 3
      ) {
        filters.brandUsers = "N"
      }
      this.props.dispatch(getUserListByFilters(filters))
      this.props.dispatch(getRolesListByFilters(filters))
      this.props.dispatch(getPermissions())
      this.props.dispatch(getEmailsOfUsers(this.props.appCode))

      const filterCount = Object.keys(_.deepClean(this.state.filters)).length
      this.setState({ filterCount })

      window.addEventListener("keydown", this._keyDownHandler)
    }
  }

  _keyDownHandler = ({ key }) => {
    if (key === "Enter" && this.state.showFilters === true) {
      return this._closeFilters()
    }
    if (key === "Escape" && this.state.showFilters === true) {
      this.setState({
        showFilters: false,
        showAdvancedFilters: false,
      })
    }
  }

  // _filteredOptions = () => {
  //   const { permissionList = [] } = this.props;
  //   const permissionArray = [];
  //   permissionList.map((item, idx) => {
  //     let label = (item.permissionId.split("_")).toString();
  //     let permissionObj = {
  //       label: label.replaceAll(",", " "),
  //       value: item.permissionId
  //     }
  //     permissionArray.push(permissionObj);
  //     // return permissionArray;
  //   })
  //   this.setState({ permissionArray });
  //   return permissionArray;
  // }

  componentDidUpdate() {
    if (this.props.refetchData) {
      let filters = _.deepClean(this.state.filters)
      this.props.dispatch(getUserListByFilters(filters))
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetState())
    window.removeEventListener("keydown", this._keyDownHandler)
  }

  _getUserUpsertForm = () => {
    if (
      this.state.formAction === "create" ||
      this.state.formAction === "update"
    ) {
      return (
        <AddUserForm
          onSubmit={this._onUpsert}
          appCode={this.state.appCode}
          data={this.state.userData}
          formAction={this.state.formAction}
          userId={this.state.userId}
          currentUser={this.props.currentUser}
          permissionList={this.props.permissionList}
          roleData={this.props.rolesList}
          emailList={this.props.emailList}
          // agencyList={this.props.agencyList}
          onCancel={() => this.setState({ showModal: false, userData: {} })}
        />
        // <CreateAppUserForm
        //   onSubmit={this._onUpsert}
        //   appCode={this.state.appCode}
        //   data={this.state.userData}
        //   formAction={this.state.formAction}
        //   userId={this.state.userId}
        //   currentUser={this.props.currentUser}
        //   permissionList={this.props.permissionList}
        //   roleData={this.props.rolesList}
        //   // agencyList={this.props.agencyList}
        //   onCancel={() => this.setState({ showModal: false, userData: {} })}
        // />
      )
    }
  }

  _handleFilterChange = (value, type) => {
    const newFilters = _.cloneDeep(this.state.filters)
    newFilters[type] = value

    if (type === "searchType") {
      newFilters["searchText"] = undefined
    }
    if (type === "searchText" || type === "order" || type === "creatorType") {
      this.setState({
        filters: newFilters,
      })
    } else {
      this.setState({
        filters: newFilters,
      })
    }
  }

  _searchUser = () => {
    // if (this.state.filters.searchType === "phone") {
    //   return this.props.dispatch(
    //     getAppUserDetails({
    //       phoneNumber: this.state.filters.searchText,
    //     })
    //   )
    // }
    let { filters } = this.state
    if (filters && filters.pageSize) {
      delete filters.currentPage
    }
    this.props.history.push(
      `/user/browse?${QueryString.stringify(_.deepClean(this.state.filters))}`
    )
    this.props.dispatch(getUserListByFilters(_.deepClean(this.state.filters)))
  }

  _removeFilter = filter => {
    const newFilters = {
      ...this.state.filters,
      [filter]: userFilters[filter].defaultValue,
    }

    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this.props.history.push(
          `/user/browse?${QueryString.stringify(
            _.deepClean(this.state.filters)
          )}`
        )
        this.props.dispatch(
          getUserListByFilters(_.deepClean(this.state.filters))
        )
      }
    )
  }

  _toggleAdvancedFilters = () => {
    this.setState({
      showAdvancedFilters: !this.state.showAdvancedFilters,
    })
  }

  _closeFilters = () => {
    this._searchUser()
    this.setState({
      showFilters: false,
      showAdvancedFilters: false,
      showForm: false,
    })
  }

  _modal = () => {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this._onModalCancel}
        footer={null}
        fullscreen={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modalTitle">{"App User"}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>{this._getUserUpsertForm()}</Row>
        </Modal.Body>
      </Modal>
    )
  }

  _onUpsert = async formData => {
    let data = {
      formData,
      query: {
        action: this.state.formAction,
        appCode: this.state.appCode,
        userId: this.state.userData?.userUUID || "",
      },
    }
    this.props.dispatch(addUser(data))
    this._onModalCancel()
  }

  _onModalCancel = () => {
    this.setState({
      showForm: false,
      showModal: false,
      userData: {},
    })
  }

  _toggleFilters = () => {
    this.setState({
      showFilters: !this.state.showFilters,
    })
  }

  _showFilters = () => {
    this.setState({
      showFilters: true,
    })
  }

  _onPageChange = value => {
    let newFilters = _.cloneDeep(this.state.filters)
    newFilters["currentPage"] = value
    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this.props.history.push(
          `/user/browse?${QueryString.stringify(
            _.deepClean(this.state.filters)
          )}`
        )
        this.props.dispatch(
          getUserListByFilters(_.deepClean(this.state.filters))
        )
      }
    )
  }

  _handleEditClick = user => {
    this.setState({
      showModal: true,
      formAction: "update",
      userData: user,
    })
  }

  render() {
    return (
      <Auxiliary
        loading={this.props.loading}
        error={_.get(this.props, "common.error")}
      >
        <React.Fragment>
          <div>
            <Container fluid>
              <Chips
                showFilters={this.state.showFilters}
                showAdvancedFilters={this.state.showAdvancedFilters}
                filters={this.state.filters}
                search={this._closeFilters}
                removeFilter={this._removeFilter}
                handleFilterChange={this._handleFilterChange}
                type="user"
                toggleFilters={this._toggleFilters}
                toggleAdvancedFilters={this._toggleAdvancedFilters}
              />
              {!this.state.showModal && (
                <div className="text-sm-end" style={{ paddingBottom: "15px" }}>
                  <Button
                    color="primary"
                    className="font-16 btn-block btn btn-primary"
                    onClick={() => {
                      if (
                        !this.props.currentUser?.permissions?.includes(
                          "ADD_USER"
                        )
                      ) {
                        toastr.error(NO_PERMISSION_MESSAGE)
                        return
                      }
                      this.setState(
                        {
                          showModal: false,
                        },
                        () =>
                          this.setState({
                            formAction: "create",
                            showModal: true,
                            userData: {},
                          })
                      )
                    }}
                  >
                    <i className="mdi mdi-plus-circle-outline me-1" />
                    Add User
                  </Button>
                </div>
              )}
              {this.props.userList && this.props.userList.length > 0 ? (
                <UserList
                  userList={this.props.userList}
                  handleEditClick={this._handleEditClick}
                  appCode={this.state.appCode}
                  onPageChange={this._onPageChange}
                  total={this.props.total}
                  searchAfter={this.props.searchAfter}
                  isMobile={this.props.isMobile}
                  currentPage={this.state.filters["currentPage"]}
                  pageSize={this.state.filters["pageSize"]}
                  currentUser={this.props.currentUser}
                  filters={this.state.filters}
                />
              ) : (
                <div>No data available</div>
              )}
              {this.state.showModal && this._modal()}
            </Container>
          </div>
        </React.Fragment>
      </Auxiliary>
    )
  }
}

function mapStateToProps(store, ownProps) {
  return {
    userList: _.get(store, "appUser.user"),
    rolesList: _.get(store, "roles.roles"),
    refetchData: _.get(store, "appUser.refetchData"),
    emailList: _.get(store, "appUser.emailList"),
    permissionList: _.get(store, "permissions.permissionList"),
    queryParams: _.get(ownProps, "location.search")
      ? QueryString.parseUrl(_.get(ownProps, "location.search")).query
      : undefined,
    total: _.get(store, "appUser.total"),
    searchAfter: _.get(store, "appUser.searchAfter"),
    common: _.get(store, "common"),
    currentUser: _.get(store, "currentUser.currentUser.data"),
    isMobile: _.get(store, "common.isMobile"),
    loading: _.get(store, "appUser.loading"),
    userDetails: _.get(store, "appUser.userDetails"),
    appCode: sessionStorage.getItem("appCode"),
  }
}

export default connect(mapStateToProps)(BrowseUser)
